import {
	FETCH_HEURES_ATELIER_BEGIN,
	FETCH_HEURES_ATELIER_ERROR,
	FETCH_HEURES_ATELIER_RESET,
	FETCH_HEURES_ATELIER_SUCCESS,
	POST_HEURE_ATELIER_BEGIN,
	POST_HEURE_ATELIER_ERROR,
	POST_HEURE_ATELIER_RESET,
	POST_HEURE_ATELIER_SUCCESS,
} from "../actions/heureActions"

const initialState = {
	heuresAtelier: [],
	fetchHeuresAtelier: {
		loading: false,
		error: false,
	},
	postHeureAtelier: {
		saving: false,
		saved: false,
		error: false,
	},
}

export default function heureReducer(state = initialState, action) {
	let heureIndex
	switch (action.type) {
		case FETCH_HEURES_ATELIER_BEGIN:
			return {
				...state,
				fetchHeuresAtelier: {
					loading: true,
					error: false,
				},
			}
		case FETCH_HEURES_ATELIER_ERROR:
			return {
				...state,
				fetchHeuresAtelier: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_HEURES_ATELIER_RESET:
			return {
				...state,
				fetchHeuresAtelier: {
					loading: false,
					error: false,
				},
			}
		case FETCH_HEURES_ATELIER_SUCCESS:
			return {
				...state,
				heuresAtelier: action.payload,
				fetchHeuresAtelier: {
					loading: false,
					error: false,
				},
			}
		case POST_HEURE_ATELIER_BEGIN:
			return {
				...state,
				postHeureAtelier: {
					saving: true,
					saved: false,
					error: false,
				},
			}
		case POST_HEURE_ATELIER_ERROR:
			return {
				...state,
				postHeureAtelier: {
					saving: false,
					saved: false,
					error: action.payload,
				},
			}
		case POST_HEURE_ATELIER_RESET:
			return {
				...state,
				postHeureAtelier: {
					saving: false,
					saved: false,
					error: false,
				},
			}
		case POST_HEURE_ATELIER_SUCCESS:
			heureIndex = state.heuresAtelier.findIndex(
				(h) => h.id === action.payload.id,
			)
			if (heureIndex === -1) {
				return {
					...state,
					postHeureAtelier: {
						saving: false,
						saved: true,
						error: false,
					},
					heuresAtelier: [...state.heuresAtelier, action.payload],
				}
			}
			return {
				...state,
				postHeureAtelier: {
					saving: false,
					saved: true,
					error: false,
				},
				heuresAtelier: [
					...state.heuresAtelier.slice(0, heureIndex),
					action.payload,
					...state.heuresAtelier.slice(heureIndex + 1),
				],
			}
		default:
			return state
	}
}
